export default __webpack_public_path__ + "static/media/instagramDeskMobile.a10d8d69.svg";